import { useEffect, useState } from 'react';
import dayjs from 'dayjs';
import { getAllReports } from '../services/api_collection';

const useGetProjectReport = (moduleType, id, date, limit = 10, page = 1) => {
  const [options, setOptions] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchListing = async () => {
      try {
        setLoading(true);
        let params = new URLSearchParams();

        params.append('limit', limit);
        params.append('page', page);
        params.append('startDate', dayjs(date).format('YYYY-MM-DD'));
        params.append('endDate', dayjs(date).format('YYYY-MM-DD'));
        id && params.append('empId', id);
        params.append('moduleType', moduleType);

        const res = await getAllReports(params);

        if (res?.statusCode === 200) {
          let array = (res?.data?.reportings || [])?.map((el, idx) => ({
            ...el,
            key: idx + 1
          }));
          setOptions(array || []);
        } else setError(res?.message || 'Something went wrong');
      } catch (err) {
        setError(err?.message || 'Something went wrong');
      } finally {
        setLoading(false);
      }
    };

    if (date) {
      fetchListing();
    }
  }, [id, date, limit, page]);

  return { options, loading, error };
};

export default useGetProjectReport;
